// Logger utility for conditional console logging in development
// In production builds, console.log statements are typically removed by minifiers
// This utility provides a consistent interface for logging

let isDevelopment = false;
try {
  // Check if we're in development mode (Vite)
  isDevelopment = import.meta.env?.DEV === true || import.meta.env?.MODE === 'development';
} catch {
  // Fallback: assume production if we can't determine
  isDevelopment = false;
}

export const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args: unknown[]) => {
    // Always log errors, even in production
    console.error(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
};

